// главная страница
export function MainPage() {
  return (
    <div className="main-page">
      <h1>Добро пожаловать</h1>
      Это главная страница журналов обращений граждан
    </div>
  );
}
